"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseMetadata_1 = require("./parseMetadata");
const splitMetadataAndContent_1 = require("./splitMetadataAndContent");
exports.loadMarkdownWithMeta = (source) => {
    const [meta, content] = splitMetadataAndContent_1.splitMetadataAndContent(source);
    return [parseMetadata_1.parseMetadata(meta), content];
};
//# sourceMappingURL=loadMarkdownWithMeta.js.map